import { render, staticRenderFns } from "./departFrom.vue?vue&type=template&id=80c6f41a&scoped=true"
import script from "./departFrom.vue?vue&type=script&lang=js"
export * from "./departFrom.vue?vue&type=script&lang=js"
import style0 from "./departFrom.vue?vue&type=style&index=0&id=80c6f41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c6f41a",
  null
  
)

export default component.exports